import styled, { css } from 'styled-components';

const textStyles = css`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 21px;
`;

export const Title = styled.h1`
  font-weight: 600;
  ${textStyles}
`;

export const TitleBox = styled.div`
  margin: 35px 0;
`;

export const Content = styled.div`
  ${textStyles}
  max-height: 70vh;
  overflow-y: auto;
`;
